import './App.css';
import { Routes, Route } from 'react-router'
import AntiVpnGuard from './components/AntiVpnGuard';

import Home from './Home';
import Stats from './Stats';
import { useEffect, useState } from 'react';
import PanelSorteo from './CrearSorteo';
import CrearSorteo from './CrearSorteo';
import CrearPrediccion from './CrearPrediccion';
import ListadoSorteos from './ListadoSorteos';
import DetalleSorteo from './DetalleSorteo';
import Callback from './Callback';
import { Box, Button, Checkbox, Grid, Modal, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import backgroundImg from './main_intro.jpg'
import { Link } from 'react-router-dom';
import { FaKickstarterK } from 'react-icons/fa6';
import { generatePKCE } from './api/pkce';
import Tipeo from './Tipeo';
import AdminPanel from './AdminPanel';
import Paneltipeo from './Paneltipeo';
import TipeoCustom from './TipeoCustom';
import Roller from './Roller';
import Tienda from './Tienda';
import { IoCloseCircleOutline } from 'react-icons/io5';
import backg from './main_intro.jpg'
import ListadoLinks from './ListadoLinks';
import DarCoins from './DarCoins';
import ListadoEventos from './ListadoEventos';
import CanjearCodigos from './CanjearCodigos';
import CrearCodigos from './CrearCodigos';
import ListaCodigos from './ListaCodigos';
import Grabar from './Grabar';
import Reproductor from './Reproductor';
import ListadoAudios from './ListadoAudios';
import Torneo from './Torneo';
import PanelTorneo from './PanelTorneo';
import ListadoNoReclamados from './ListadoNoReclamados';
import DarTipeo from './DarTipeo';
import Bonos from './Bonos';
import Bonus from './Bonus';
import MenuTipeos from './MenuTipeos';
import BetWinner from './BetWinner';
import BonusBet from './BonusBet';
import VerificarBet from './VerificarBet';
import Verificar1xBet from './Verificar1xBet';
import PanelDinamico from './PanelDinamico';
import Guias from './Guias';
import ListadoRankings from './ListadoRankings';
import UltimoRanking from './UltimoRanking';
import DetalleRanking from './DetalleRanking';
import ListadoBlacklist from './ListadoBlacklist';
import ListadoBNB from './ListadoBNB';
import logo from './img/logoDs.png'
import Blacklistpublica from './Blacklistpublica';
import MisSolicitudes from './MisSolicitudes';
import TelegramAuthPage from './TelegramAuthPage';
import PoliticaPrivacidad from './PoliticaPrivacidad';
import AndroidBetaModal from './components/AndroidBetaModal';
import IosBetaModal from './components/IosBetaModal';
import AutoAppOpener from './components/AutoAppOpener';
import AcreditacionesTipeo from './AcreditacionesTipeo';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'rgba(20, 20, 20, 0.95)',
    borderRadius: 4,
    boxShadow: 24,
    backdropFilter: 'blur(8px)',
    p: 4,
    textAlign: 'center',
};

const buttonBase = {
    px: 3,
    py: 1.5,
    fontSize: '1rem',
    fontWeight: 'bold',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '12px',
    background: 'transparent',
    transition: '0.3s ease',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
};
function App() {
    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;
    const location = useLocation(); // Captura la URL actual
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const nombre = localStorage.getItem('kick_user')
    const generateRouteKey = () => {
        return Math.random()
            .toString(36)
            .substring(2, 12);
    };


    const getRouteKey = (name) => {

        let key = localStorage.getItem(name);

        if (!key) {
            key = generateRouteKey();
            localStorage.setItem(name, key);
        }

        return key;
    };


    const ROUTES = {
        coins: getRouteKey("route_coins"),
        tipeos: getRouteKey("route_tipeos"),
        limiteTipeos: getRouteKey("route_limite_tipeos"),
        enviarPush: getRouteKey("route_enviar_push"),
        acreditaciones: getRouteKey("route_acreditaciones"),
    };
    const RutaPrivada = ({ children }) => {
        const usuario = localStorage.getItem('fbUser')?.replaceAll('"', "");
        const usuarioKick = localStorage.getItem('kick_user')
        const jwtToken = localStorage.getItem('kick_jwt')

        const isSorteoRoute = location.pathname.startsWith('/sorteo/');
        const isTorneoRoute = location.pathname.startsWith('/torneo/');
        const isTipeoRoute = location.pathname.startsWith('/tipeos/');
        const isMenuTipeosRoute = location.pathname.startsWith('/menu-tipeos/');
        const isPrediccionRoute = location.pathname.startsWith('/crearPrediccion');
        console.log('usuarioKick', usuarioKick)
        const isLoggedIn = usuario || usuarioKick;
        const cleanKick = String(usuarioKick || '').replace(/['"]/g, '').trim().toLowerCase();
        const cleanMail = String(localStorage.getItem('kick_mail') || '').replace(/['"]/g, '').trim().toLowerCase();
        const isAllowedAdminUser =
            cleanKick === 'eldenguee' ||
            cleanKick === 'lucaslunacl' ||
            ['lucaslunaclaraso@gmail.com', 'chinosc.96@gmail.com', 'eldenguee@gmail.com'].includes(cleanMail);

        // Verificar si el usuario es válido (incluye tanto fbUser como kick_user)
        const isValidUser =
            (isSorteoRoute && isLoggedIn) || (isTipeoRoute && isLoggedIn) || // Si es sorteo, todos pueden acceder
            (isTorneoRoute && isLoggedIn) ||
            (isMenuTipeosRoute && isLoggedIn) ||
            isAllowedAdminUser ||
            (usuario === 'Lucas Luna' || usuario === 'Luis San Cristobal');
        const [open, setOpen] = useState(false);

        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
        const [isChecked, setIsChecked] = useState(false);

        const handleCheckboxChange = (event) => {
            setIsChecked(event.target.checked);
        };

        const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'rgba(20, 20, 20, 0.95)',
            borderRadius: 4,
            boxShadow: 24,
            backdropFilter: 'blur(8px)',
            textAlign: 'center',
            backgroundImage: `
            linear-gradient(to bottom,  rgba(63, 61, 69, 0),rgb(73 22 227)),
            url(${backg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            padding: isMobile ? '35px' : '150px 56px 56px'
        };

        const loginWithKick = async () => {

            const { code_verifier, code_challenge } = await generatePKCE();
            localStorage.setItem('kick_code_verifier', code_verifier);

            const criptoRandom = crypto.randomUUID()

            const state = isTorneoRoute || isSorteoRoute || isTipeoRoute ? encodeURIComponent(location.pathname) : encodeURIComponent('/');
            const params = new URLSearchParams({
                response_type: 'code',
                client_id: '01JW6K1RY4R70K7B6KSJ8GK5CV',
                redirect_uri: 'https://eldenguee.com/callback',
                scope: 'chat:write channel:read user:read events:subscribe',
                code_challenge: code_challenge,
                code_challenge_method: 'S256',
                state: state,
            });

            window.location.href = `https://id.kick.com/oauth/authorize?${params.toString()}`;
        };
        if (!isValidUser) {
            // Mostrar un mensaje de advertencia y redirigir al login
            return (
                <Grid
                    sx={{
                        minHeight: '100vh',
                        background: `
                linear-gradient(rgba(8,10,18,.82), rgba(8,10,18,.92)),
                url(${backgroundImg})
            `,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 3,
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Glow */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            borderRadius: "50%",
                            background: "#53FC18",
                            filter: "blur(180px)",
                            opacity: .08,
                            top: -150,
                            left: -150,
                        }}
                    />

                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            borderRadius: "50%",
                            background: "#2f80ed",
                            filter: "blur(180px)",
                            opacity: .12,
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Box
                        sx={{
                            width: 520,
                            maxWidth: "100%",
                            background: "rgba(15,18,28,.82)",
                            backdropFilter: "blur(30px)",
                            border: "1px solid rgba(255,255,255,.08)",
                            borderRadius: "28px",
                            padding: isMobile ? 4 : 6,
                            textAlign: "center",
                            boxShadow: "0 30px 80px rgba(0,0,0,.45)",
                            zIndex: 2,
                        }}
                    >
                        <img
                            src={logo}
                            alt=""
                            style={{
                                width: 70,
                                marginBottom: 25
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#FFF",
                                fontWeight: 700,
                                fontSize: isMobile ? 30 : 38,
                                fontFamily: "Outfit"
                            }}
                        >
                            Acceso Restringido
                        </Typography>

                        <Typography
                            sx={{
                                color: "#9CA3AF",
                                mt: 2,
                                mb: 5,
                                lineHeight: 1.7,
                                fontFamily: "Outfit"
                            }}
                        >
                            Iniciá sesión con tu cuenta de Kick.
                        </Typography>



                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1.5,
                                mb: 4,
                                textAlign: "left"
                            }}
                        >
                            <Checkbox
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                sx={{
                                    color: "#53FC18",
                                    '&.Mui-checked': {
                                        color: "#53FC18"
                                    }
                                }}
                            />

                            <Typography
                                sx={{
                                    color: "#9CA3AF",
                                    fontSize: 14,
                                    fontFamily: "Outfit"
                                }}
                            >
                                Confirmo que soy mayor de 18 años y acepto los términos y
                                condiciones del sitio.
                            </Typography>
                        </Box>

                        <Button
                            fullWidth
                            disabled={!isChecked}
                            startIcon={<FaKickstarterK size={22} />}
                            onClick={loginWithKick}
                            sx={{
                                height: 58,
                                borderRadius: "18px",
                                fontWeight: 700,
                                fontSize: 16,
                                textTransform: "none",
                                color: "#111",
                                background:
                                    "linear-gradient(135deg,#53FC18,#31d158)",
                                boxShadow: "0 15px 35px rgba(83,252,24,.30)",
                                transition: ".25s",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg,#63ff32,#53FC18)",
                                    transform: "translateY(-3px)",
                                    boxShadow:
                                        "0 25px 50px rgba(83,252,24,.40)"
                                },

                                "&.Mui-disabled": {
                                    background: "#2b2b2b",
                                    color: "#666"
                                }
                            }}
                        >
                            Continuar con Kick
                        </Button>

                        <Typography
                            sx={{
                                color: "#6B7280",
                                mt: 3,
                                fontSize: 13,
                                fontFamily: "Outfit"
                            }}
                        >
                            Eldenguee © 2026
                        </Typography>
                    </Box>
                </Grid>
            );
        }

        return children;
    };
    const styles = {
        mensaje: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '20px',
        },
    };
    const [sorteos, setSorteos] = useState([]);
    return (
        <AntiVpnGuard activeUser={nombre} strictMode={false}>
            <div className="App">
                <AutoAppOpener />
                <AndroidBetaModal />
                {/* <IosBetaModal /> */}
                <Routes>

                    <Route exact path='/' element={<Home isMobile={isMobile} />} />
                    <Route path='/stats' element={<Stats />} />

                    <Route path='/panel' element={<RutaPrivada><CrearSorteo isMobile={isMobile} sorteos={sorteos} setSorteos={setSorteos} /> </RutaPrivada>} />
                    <Route path='/crearlink' element={<RutaPrivada><Paneltipeo isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/tipeos/:url" element={<TipeoCustom isMobile={isMobile} />} />

                    <Route path="/listado" element={<RutaPrivada><ListadoSorteos sorteos={sorteos} /> </RutaPrivada>} />
                    <Route path="/eventos" element={<RutaPrivada><ListadoEventos sorteos={sorteos} /> </RutaPrivada>} />

                    <Route path="/sorteo/:url" element={<RutaPrivada><DetalleSorteo sorteos={sorteos} setSorteos={setSorteos} isMobile={isMobile} /> </RutaPrivada>} />

                    <Route path='/crearTorneo' element={<RutaPrivada><PanelTorneo isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path='/crearPrediccion' element={<RutaPrivada><CrearPrediccion isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/torneo/:url" element={<RutaPrivada><Torneo isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/listadoTorneos" element={<RutaPrivada><ListadoSorteos isMobile={isMobile} /> </RutaPrivada>} />

                    <Route path="/solicitudes" element={<RutaPrivada><AdminPanel isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/acreditaciones" element={<RutaPrivada><AcreditacionesTipeo isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/historial-tipeos" element={<RutaPrivada><AcreditacionesTipeo isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/grabar" element={<Grabar nombre={nombre} isMobile={isMobile} />} />
                    <Route path="/audio" element={<Reproductor isMobile={isMobile} />} />

                    <Route path="/callback" element={<Callback />} />
                    <Route path="/listalinks" element={<RutaPrivada><ListadoLinks isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/listaaudios" element={<RutaPrivada><ListadoAudios isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/listanoreclamados" element={<RutaPrivada><ListadoNoReclamados isMobile={isMobile} /> </RutaPrivada>} />
                    <Route
                        path="/panel/:key"
                        element={
                            <RutaPrivada>
                                <PanelDinamico />
                            </RutaPrivada>
                        }
                    />

                    {/* <Route path="/tipeo" element={<BetWinner nombre={nombre} isMobile={isMobile} />} /> */}
                    <Route path="/bonos" element={<Bonos nombre={nombre} isMobile={isMobile} />} />
                    {/* <Route path="/bonus1xbet" element={<Bonus nombre={nombre} isMobile={isMobile} />} /> */}
                    {/* <Route path="/bonusBetWinner" element={<BonusBet nombre={nombre} isMobile={isMobile} />} /> */}
                    {/* <Route path="/verificarBet" element={<VerificarBet nombre={nombre} isMobile={isMobile} />} /> */}
                    <Route path="/verificar1xBet" element={<Verificar1xBet nombre={nombre} isMobile={isMobile} />} />
                    <Route path="/canjear" element={<CanjearCodigos isMobile={isMobile} />} />
                    <Route path="/crearCode" element={<RutaPrivada><CrearCodigos isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/listaCodigos" element={<RutaPrivada><ListaCodigos isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/ruleta" element={<Roller nombre={nombre} />} />
                    <Route path="/shop" element={<Tienda nombre={nombre} isMobile={isMobile} />} />
                    <Route path="/menu-tipeos" element={<MenuTipeos nombre={nombre} isMobile={isMobile} />} />
                    <Route path="/guias" element={<Guias isMobile={isMobile} />} />
                    <Route path="/rankings" element={<UltimoRanking isMobile={isMobile} />} />
                    <Route path="/ranking/:id" element={<RutaPrivada><DetalleRanking isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/listadoRankings" element={<RutaPrivada><ListadoRankings isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/blacklist" element={<RutaPrivada><ListadoBlacklist isMobile={isMobile} /> </RutaPrivada>} />
                    <Route path="/listadobnb" element={<RutaPrivada><ListadoBNB isMobile={isMobile} /></RutaPrivada>} />
                    <Route path="/listaBlacklist" element={<Blacklistpublica isMobile={isMobile} />} />
                    <Route path="/mis-solicitudes" element={<MisSolicitudes isMobile={isMobile} />} />
                    <Route path="/verificar-telegram" element={<TelegramAuthPage />} />
                    <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                    <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
                    <Route path="/privacy-policy" element={<PoliticaPrivacidad />} />
                    <Route path="/privacy" element={<PoliticaPrivacidad />} />
                </Routes>
            </div>
        </AntiVpnGuard>
    );
}

export default App;
